import { UserContextProvider } from 'providers/UserProvider';
import { ApiUserRepository } from 'services/repositories/implementations/ApiUserRepository';
import { Endpoints } from 'utils/endpoints.ts';
import { ShareDocumentButtonPopover } from 'components/editor/EditorMenu/ShareV3/ShareDocumentButtonPopover.tsx';
import PdfDownloadButton from '../Download/PdfDownloadButton.tsx';

interface MenuProps {
  contentId: string;
  documentId: string;
  documentTitle: string;
  documentProspectName: string;
  canViewShareButton?: boolean;
}

export function PreviewActionMenu({ contentId, documentId, documentTitle, documentProspectName, canViewShareButton = false }: MenuProps) {
  const previewURL = Endpoints.getDocumentPreviewPage(documentId);
  const documentTitleWithProspectName = [documentTitle, documentProspectName].filter(Boolean).join(' - ');

  return canViewShareButton ? (
    <UserContextProvider userRepository={new ApiUserRepository()}>
      <ShareDocumentButtonPopover
        contentId={contentId}
        previewURL={previewURL}
        documentTitleWithCompanyName={documentTitleWithProspectName}
        canShare={true}
      />
    </UserContextProvider>
  ) : (
    <PdfDownloadButton contentId={contentId} documentId={documentId} fileName={documentTitleWithProspectName} />
  );
}
